import { UpdateWaterfallBundleConfigurationInput } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createFlatConfigDescriptor } from './flatConfigDescriptor';

export const waterfallOverviewBundleDescriptor: BundleSaveDescriptor =
  createFlatConfigDescriptor({
    field: 'waterfallOverviewBundleConfiguration',
    read: (bundle) => bundle.waterfallOverviewBundleConfiguration,
    diff: (previous, next, previousBundle, nextBundle) => {
      const update: UpdateWaterfallBundleConfigurationInput = {};

      if (previousBundle.displayName !== nextBundle.displayName) {
        if (nextBundle.displayName) {
          update.displayName = nextBundle.displayName;
        } else {
          update.clearDisplayName = true;
        }
      }
      if (previous.includeCoverPage !== next.includeCoverPage) {
        update.includeCoverPage = next.includeCoverPage;
      }
      if (previous.includeAssumptionsPage !== next.includeAssumptionsPage) {
        update.includeAssumptionsPage = next.includeAssumptionsPage;
      }
      if (previous.includeDiagramPage !== next.includeDiagramPage) {
        update.includeDiagramPage = next.includeDiagramPage;
      }
      if (previous.includeSummaryPage !== next.includeSummaryPage) {
        update.includeSummaryPage = next.includeSummaryPage;
      }
      if (previous.includeSummaryBars !== next.includeSummaryBars) {
        update.includeSummaryBars = next.includeSummaryBars;
      }
      if (previous.includeSummaryTiles !== next.includeSummaryTiles) {
        update.includeSummaryTiles = next.includeSummaryTiles;
      }
      if (previous.showSummaryTileDetails !== next.showSummaryTileDetails) {
        update.showSummaryTileDetails = next.showSummaryTileDetails;
      }
      if (previous.useUpdatedSummaryPage !== next.useUpdatedSummaryPage) {
        update.useUpdatedSummaryPage = next.useUpdatedSummaryPage;
      }
      if (previous.includeOverview !== next.includeOverview) {
        update.includeOverview = next.includeOverview;
      }
      if (previous.includeBeforeFirstDeath !== next.includeBeforeFirstDeath) {
        update.includeBeforeFirstDeath = next.includeBeforeFirstDeath;
      }
      if (previous.includeAfterFirstDeath !== next.includeAfterFirstDeath) {
        update.includeAfterFirstDeath = next.includeAfterFirstDeath;
      }
      if (previous.includeAfterSecondDeath !== next.includeAfterSecondDeath) {
        update.includeAfterSecondDeath = next.includeAfterSecondDeath;
      }
      if (
        previous.summaryHideZeroDollarItems !== next.summaryHideZeroDollarItems
      ) {
        update.summaryHideZeroDollarItems = next.summaryHideZeroDollarItems;
      }
      if (previous.includeTaxOverviewPage !== next.includeTaxOverviewPage) {
        update.includeTaxOverviewPage = next.includeTaxOverviewPage;
      }
      if (previous.firstDeathYear !== next.firstDeathYear) {
        update.firstDeathYear = next.firstDeathYear;
      }
      if (previous.secondDeathYear !== next.secondDeathYear) {
        if (next.secondDeathYear == null) {
          update.clearSecondDeathYear = true;
        } else {
          update.secondDeathYear = next.secondDeathYear;
        }
      }
      if (previous.growthProfileId !== next.growthProfileId) {
        if (next.growthProfileId) {
          update.growthProfileID = next.growthProfileId;
        } else {
          update.clearGrowthProfile = true;
        }
      }
      if (previous.estateWaterfallId !== next.estateWaterfallId) {
        if (next.estateWaterfallId) {
          update.estateWaterfallID = next.estateWaterfallId;
        } else {
          update.clearEstateWaterfall = true;
        }
      }

      return Object.keys(update).length > 0 ? update : null;
    },
    toPayload: (id, update) => ({
      updateWaterfallBundleConfiguration: { id, update },
    }),
  });
